import { createContext } from 'react';
/**
 * @public
 */

var PresenceContext = createContext(null);
export { PresenceContext };